import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Typography, TypographyProps } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => createStyles({
	root: {
		...theme.typography.body1,
		fontSize: '1.125rem',
		fontWeight: 600,
		textAlign: 'center',
	},
}));

const AlertUser: React.FC<TypographyProps> = ({ children, className, ...props }) => {
	const classes = useStyles();

	return (
		<Typography
			variant="body1"
			className={classNames(classes.root, className)}
			{...props}
		>
			{children}
		</Typography>
	);
};

export default AlertUser;
